import { render, staticRenderFns } from "./CorpPolityPage.vue?vue&type=template&id=1ce5a9a8"
import script from "./CorpPolityPage.vue?vue&type=script&lang=js"
export * from "./CorpPolityPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports